import { store } from 'redux/store';
import { getMerchantId } from 'redux/reducers/auth/selectors';
import { DeviceInfo, collectDeviceInfo } from 'services/deviceInfo';
import { SHOPIFY_REMOTE_ACCESS_TOKEN } from 'services/constants/env';
import { authManager } from 'services/auth';
import { IAxiosRequestConfig } from './types';

const withAuthorization = async (
	config: IAxiosRequestConfig,
	format: (token: string) => string,
): Promise<IAxiosRequestConfig> => {
	const requestConfig = config;
	const accessToken = await authManager.getAccessToken();

	if (!accessToken) return requestConfig;

	requestConfig._accessToken = accessToken;
	requestConfig.headers = {
		...requestConfig.headers,
		Authorization: format(accessToken),
	};

	return requestConfig;
};

const asIs = (token: string): string => token;
const asBearer = (token: string): string => `Bearer ${token}`;

// ==========================================:
export const onSuccess = async (config: IAxiosRequestConfig): Promise<IAxiosRequestConfig> => {
	const requestConfig = await withAuthorization(config, asIs);
	const deviceInfo: DeviceInfo = collectDeviceInfo();
	const xMerchantId = getMerchantId(store.getState());

	requestConfig.headers = {
		...requestConfig.headers,
		...deviceInfo,
		...(xMerchantId ? { 'X-Merchant-Id': xMerchantId } : {}),
	};

	return requestConfig;
};

// ==========================================:

export const onSuccessQ4US = (config: IAxiosRequestConfig): Promise<IAxiosRequestConfig> =>
	withAuthorization(config, asBearer);

export const onSuccessPay = (config: IAxiosRequestConfig): Promise<IAxiosRequestConfig> =>
	withAuthorization(config, asBearer);

// ==========================================:

export const onSuccessShopify = (config: IAxiosRequestConfig) => {
	const requestConfig = config;

	requestConfig.headers = {
		...requestConfig.headers,
		'x-remote-access-token': SHOPIFY_REMOTE_ACCESS_TOKEN,
	};

	return requestConfig;
};
